import { constUrlBase } from "constants/api";
import { useDispatch, useSelector } from "react-redux";
import { changeTabActiveMobile } from "store/actionReducers/StocksAnalysisStore";
import BoxListChart from "./components/BoxListChart";
import BackTestV2 from "./components/BoxListChart/BackTestV2";
import Growth from "./components/BoxListChart/Growth";
import Momentum from "./components/BoxListChart/Momentum";
import Value from "./components/BoxListChart/Value";
import DSCReviews from "./components/DSCReviews";
import NewsStock from "./components/NewsStock";
import SelectStocks from "./components/SelectStocks";
import { Helmet } from "react-helmet";

import './StockAnalysis.scss'
import { useEffect } from "react";
import { changeMenu, colspanMenu } from "store/actionReducers/MenuStore";

export default function StockAnalysis() {
  const CompanyStore = useSelector((state) => state?.CompanyStore)
  const StocksAnalysisStore = useSelector((state) => state?.StocksAnalysisStore)
  const tabActiveMobile = StocksAnalysisStore?.tabActiveMobile
  const dispatch = useDispatch();

  const objectCompany = CompanyStore?.allCompany.filter((item) => {
    return item?.code === StocksAnalysisStore?.inputSearch ? item?.organname : ''
  })
  const companyName = objectCompany?.[0]?.organname || ''
  const exchange = objectCompany?.[0]?.exchange || ''

  const handleChangePageActive = (tab) => {
    dispatch(changeTabActiveMobile({ tabActiveMobile: tab }))
  }
  
  const priceClose = StocksAnalysisStore?.priceStockAnalysis[StocksAnalysisStore?.inputSearch]?.priceClose
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{constUrlBase.phan_tich_co_phieu.title(StocksAnalysisStore?.inputSearch, companyName)}</title>
        <meta name="description" content={constUrlBase.phan_tich_co_phieu.description(StocksAnalysisStore?.inputSearch, priceClose)} />
      </Helmet>
      <div className="HmkOUjWgbo">
        <div className="uLLuovDdsq">
          <SelectStocks />
        </div>
        <div className="knyuHCdUvW">
          <DSCReviews />
        </div>
      </div>

      <div className={`jqmrrvkmgd ${tabActiveMobile ? 'vaytwwhkrh' : ''}`}>
        <div className='jswyvdolxb'>
          <div className="vHTgvywnjz">
            <div onClick={() => handleChangePageActive('tang-truong')} className={`dbSHFWzcaE ${tabActiveMobile === 'tang-truong' ? 'pLPTyGolrf' : ''}`}>Tăng trưởng</div>
            <div onClick={() => handleChangePageActive('gia-tri')} className={`dbSHFWzcaE ${tabActiveMobile === 'gia-tri' ? 'pLPTyGolrf' : ''}`}>Giá trị</div>
            <div onClick={() => handleChangePageActive('dong-luong')} className={`dbSHFWzcaE ${tabActiveMobile === 'dong-luong' ? 'pLPTyGolrf' : ''}`}>Động lượng</div>
            <div onClick={() => handleChangePageActive('back-test')} className={`dbSHFWzcaE ${tabActiveMobile === 'back-test' ? 'pLPTyGolrf' : ''}`}>Back test</div>
          </div>
          <div className="jflfsgvnsi">
            {tabActiveMobile === 'tang-truong' ? <Growth /> : null}
            {tabActiveMobile === 'gia-tri' ? <Value /> : null}
            {tabActiveMobile === 'dong-luong' ? <Momentum /> : null}
            {tabActiveMobile === 'dsc' ? <BackTestV2 /> : null}
          </div>
        </div>
      </div>
      <div className="zlpiokjudh">
        <div className="mgLiSEYfTV">
          <BoxListChart />
        </div>
        <div className="rfJyLctysf">
          <NewsStock />
        </div>
      </div>
    </>
  )
}